module.exports = __webpack_public_path__ + "static/media/dashboard_form_preview.eb08423d.png";